import { render, staticRenderFns } from "./bomComment.vue?vue&type=template&id=6d327b12&scoped=true&"
import script from "./bomComment.vue?vue&type=script&lang=js&"
export * from "./bomComment.vue?vue&type=script&lang=js&"
import style0 from "./bomComment.vue?vue&type=style&index=0&id=6d327b12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d327b12",
  null
  
)

export default component.exports